<div class="iniziativecontainer">
    <a href="/cifris24/scientific-session">
        <mat-card mat-button class="scientific">
            <mat-card-content class="txtbtn-txt">
                <b>Scientific Session</b>
                <br>
                <i class="smaller">
                    Research articles
                </i>
            </mat-card-content>
        </mat-card>
    </a>
    <a href="/cifris24/institutional-session">
        <mat-card mat-button class="institutional">
            <mat-card-content class="txtbtn-txt">
                <b>Institutional Session</b>
                <br>
                <i class="smaller">
                    Roundtables and talks
                </i>
            </mat-card-content>
        </mat-card>
    </a>
</div>